import {
  NumberRangeInput,
  type NumberRangeValue,
} from "../NumberRangeInput";
import { InputColumnFilterContainer } from "./InputColumnFilterContainer";

interface NumberRangeColumnFilterFieldProps {
  value: NumberRangeValue;
  min?: number;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  onChange: (value: NumberRangeValue) => void;
}

export function NumberRangeColumnFilterField({
  value,
  min,
  minPlaceholder,
  maxPlaceholder,
  onChange,
}: NumberRangeColumnFilterFieldProps) {
  return (
    <InputColumnFilterContainer>
      <NumberRangeInput
        value={value}
        onChange={onChange}
        min={min}
        minPlaceholder={minPlaceholder}
        maxPlaceholder={maxPlaceholder}
      />
    </InputColumnFilterContainer>
  );
}
